import React from "react";
import OwlCarousel from "react-owl-carousel";

export default function Screenshot({ hasBg }) {
  const options = {
    loop: true,
    margin: 0,
    center: true,
    dots: true,
    nav: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 3,
      },
      991: {
        items: 4,
      },
      1200: {
        items: 4,
      },
      1920: {
        items: 4,
      },
    },
  };
  return (
    <>
      <section
        id="screenshots"
        className={`screenshots-section ptb-100 ${hasBg ? "gray-light-bg" : ""
          }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Mira
                  </span>
                ) : (
                  ""
                )}
                <h2>Nuestra App</h2>
                <p className="lead">
                  Simplificamos los procesos de compra y retiro en pocos clicks. Monetiza tu contenido de manera unica y profesional.
                </p>
              </div>
            </div>
          </div>
          <div className="screen-slider-content mt-5">
            <div className="screenshot-frame"></div>
            <OwlCarousel
              className="screen-carousel owl-carousel owl-theme dot-indicator"
              {...options}
            >
              <img
                src="assets/img/CapturaP9.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/CapturaP1.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/CapturaP2.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              {/* <img
                src="assets/img/CapturaP3.jpg"
                className="img-fluid"
                alt="screenshots"
              /> */}
              <img
                src="assets/img/CapturaP4.jpg"
                className="img-fluid"
                alt="screenshots"
              />
                                         <img
                src="assets/img/CapturaP10.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/CapturaP5.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/CapturaP6.jpg"
                className="img-fluid"
                alt="screenshots"
              />
              <img
                src="assets/img/CapturaP7.jpg"
                className="img-fluid"
                alt="screenshots"
              />

            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
}
